import script from "./CollectionCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionCard.vue?vue&type=script&setup=true&lang=ts"

import "./CollectionCard.vue?vue&type=style&index=0&id=cf688f3a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf688f3a"]])

export default __exports__